"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$PaymentMethodCard = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$PaymentMethodCard = {
    properties: {
        brand: {
            type: 'string',
        },
        checks: {
            type: 'dictionary',
            contains: {
                properties: {},
            },
        },
        country: {
            type: 'string',
        },
        exp_month: {
            type: 'number',
        },
        exp_year: {
            type: 'number',
        },
        fingerprint: {
            type: 'string',
        },
        funding: {
            type: 'string',
        },
        generated_from: {
            type: 'string',
        },
        last4: {
            type: 'string',
        },
        networks: {
            type: 'dictionary',
            contains: {
                properties: {},
            },
        },
        three_d_secure_usage: {
            type: 'dictionary',
            contains: {
                properties: {},
            },
        },
        wallet: {
            type: 'dictionary',
            contains: {
                properties: {},
            },
        },
    },
};
